import { createSelector } from 'reselect'
import { sumBy } from 'lodash'
import { Helpers } from 'finance'
import { selectCurrentCELs } from './dictionary'
import { selectHomeValue } from 'src/store/selectors/home/metadata'

const getHomeSoldPrice = state => state.home.data.soldPrice

const getAVMAppreciationPercent = (price, avm) =>
  price ? Helpers.getAppreciationPercent(avm, price) : null

export const selectAVMAppreciationPercent = createSelector(
  getHomeSoldPrice,
  selectHomeValue,
  getAVMAppreciationPercent
)

export const selectOutstandingPrincipal = createSelector(
  selectCurrentCELs,
  dict => sumBy(dict.loans(), 'progress.principalLeft')
)

const getAVMEquity = (currentValue, outstandingPrincipal) =>
  currentValue - outstandingPrincipal

export const selectAVMEquity = createSelector(
  selectHomeValue,
  selectOutstandingPrincipal,
  getAVMEquity
)
